export enum RobinhoodRateSource {
  Sage = 'Sage',
  National = 'National',
}

export const RobinhoodLoanPurpose = ['purchase', 'refinance']

export enum RobinhoodEventType {
  RateLocked = 'rate_locked',
  ClearToClose = 'clear_to_close',
  Funded = 'funded',
  ApplicationCompleted = 'application_completed',
}
